const initialState = {
  courses: [],
};

const courseReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD":
      const item = state.courses && state.courses.length > 0 ? [...state.courses, action.payload.courses] : [action.payload.courses];
      return {
        ...state,
        courses: item,
      };
    case "HYDRATE":
      return {
        ...state,
        ...(action.payload.courses !== undefined && {
          courses: action.payload.courses,
        }),
      };
    case "EMPTY":
      return {
        ...state,
        courses: [],
      };

    default:
      return state;
  }
};

export default courseReducer;
